<template>
    <div class="social-share-block" v-if="currentPage">
        <span class="text">
            Del artikkelen
        </span>
        <SocilaSharing
            :url="currentPage.link"
            :title="currentPage.title"
            :description="currentPage.excerpt"
            inline-template
        >
            <div class="sharing-icons">
                <network network="facebook">
                    <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <path fill="#00344D" d="M20,9.98050682 C20,4.4692678 15.5307322,0 10.0194932,0 C4.50825415,0 0.0389863548,4.4692678 0.0389863548,9.98050682 C0.0389863548,15.4917458 4.50825415,19.9610136 10.0194932,19.9610136 C10.078125,19.9610136 10.1364522,19.9597953 10.1949318,19.9587293 L10.1949318,12.1893275 L8.05068226,12.1893275 L8.05068226,9.69039353 L10.1949318,9.69039353 L10.1949318,7.85148635 C10.1949318,5.71881092 11.4968628,4.5580531 13.3992751,4.5580531 C14.3102766,4.5580531 15.093354,4.62597466 15.3216374,4.65628047 L15.3216374,6.88520347 L14.0098075,6.88520347 C12.9748416,6.88520347 12.7744274,7.3771016 12.7744274,8.09880604 L12.7744274,9.69039353 L15.2491472,9.69039353 L14.926596,12.1893275 L12.7744274,12.1893275 L12.7744274,19.5754142 C16.9461196,18.3794773 20,14.5361233 20,9.98050682 Z" ></path> </svg>
                </network>
                <network network="twitter">
                    <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <path fill="#00344D" d="M10,0 C4.47799684,0 0,4.47799684 0,10 C0,15.5220032 4.47799684,20 10,20 C15.5220032,20 20,15.5220032 20,10 C20,4.47799684 15.5220032,0 10,0 Z M14.5658875,7.79693602 C14.5703125,7.89535523 14.5724487,7.99423219 14.5724487,8.09356688 C14.5724487,11.1265564 12.2637939,14.6240234 8.04183961,14.624176 L8.04199219,14.624176 L8.04183961,14.624176 C6.74560547,14.624176 5.5393982,14.2442322 4.52362063,13.5931396 C4.70321656,13.6143494 4.88601684,13.6248779 5.07110594,13.6248779 C6.14654539,13.6248779 7.13623047,13.2580566 7.92190551,12.6423645 C6.91711426,12.6237488 6.06994629,11.9601441 5.77758789,11.0481262 C5.91751098,11.0749817 6.06140137,11.0896301 6.20895387,11.0896301 C6.41845703,11.0896301 6.62139891,11.0614014 6.81427,11.0087586 C5.76400758,10.7984924 4.97283938,9.87030031 4.97283938,8.75885008 C4.97283938,8.74847414 4.97283938,8.73916625 4.97314453,8.7295532 C5.2824402,8.90151977 5.63613891,9.00497438 6.01272582,9.01657105 C5.39642336,8.60534668 4.9913025,7.90237426 4.9913025,7.10601805 C4.9913025,6.68548586 5.10498047,6.29150391 5.30212402,5.95230102 C6.43402102,7.34115602 8.12561035,8.25454711 10.0332641,8.35052492 C9.99389648,8.18237305 9.9736023,8.00720215 9.9736023,7.82714844 C9.9736023,6.56005859 11.0015869,5.53207398 12.2691345,5.53207398 C12.9293823,5.53207398 13.5256958,5.81115723 13.9445496,6.25732422 C14.4674683,6.1541748 14.9584961,5.96313477 15.4020691,5.70022582 C15.2304077,6.23596191 14.8666382,6.68548586 14.3927002,6.96975707 C14.8570252,6.91421508 15.29953,6.79107664 15.7107544,6.60827637 C15.403595,7.06863402 15.0140381,7.47299195 14.5658875,7.79693602 Z"></path></svg>
                </network>
                <network  network="email">
                    <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <path fill="#00344D" d="M15.5883906,7.02221875 C15.662125,6.95921875 15.766375,6.94482812 15.8549922,6.98607812 C15.9433516,7.02685937 16,7.11547656 16,7.21288281 L16,7.21288281 L16,13.4999922 C16,14.0515234 15.5515234,14.5 15.0000156,14.5 L15.0000156,14.5 L5,14.5 C4.44847656,14.5 4,14.0515234 4,13.4999922 L4,13.4999922 L4,7.21288281 C4,7.11547656 4.05664844,7.02709375 4.14500781,6.98605469 C4.23289844,6.94529687 4.33738281,6.95919531 4.41160937,7.02219531 C5.9025625,8.285875 8.52025,10.5112187 9.30198437,11.2155625 C9.71457812,11.5876328 10.2858672,11.5876328 10.6975,11.2160547 C11.4309062,10.5551875 13.7619531,8.57054687 15.5883906,7.02221875 Z M14.9999922,5.5 C15.3066484,5.5 15.5927734,5.64039063 15.7846797,5.88524219 C15.8676953,5.99120313 15.8520625,6.14354688 15.7495234,6.23021875 C14.1025469,7.62500781 11.2126563,10.0791016 10.3625547,10.8449687 C10.2487891,10.9477422 10.1267031,10.99975 10,10.99975 C9.87303906,10.99975 9.75074219,10.94725 9.63671875,10.8439844 C8.78734375,10.0788672 5.89745313,7.62500781 4.2505,6.23021875 C4.14796094,6.14354688 4.13232813,5.99120313 4.21534375,5.88526562 C4.40722656,5.64039063 4.693375,5.5 5.00000781,5.5 L5.00000781,5.5 Z M10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 Z" ></path> </svg>
                </network>
            </div>
        </SocilaSharing>
    </div>
</template>

<script>
// https://www.npmjs.com/package/vue-social-sharing
import SocilaSharing from 'vue-social-sharing';
import { mapGetters } from 'vuex';

export default {
    name: 'share-links',
    components:{
        SocilaSharing
    },
    computed:{
        ...mapGetters([
            'currentPage'
        ]),
    },
    
};
</script>


<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.social-share-block{
    display: flex;
    align-items: center;
    font-weight: bold;
    max-width: 800px;
    @include fluid-type($smallResText, $wideResText, 16px, 18px);
    .sharing-icons{
        margin-left: 15px;
        cursor: pointer;
        span{
            display: inline-block;
            margin-right: 15px;
            svg{
                display: block;
                width: 30px;
                height: 30px;
                path{
                    transition: fill 0.2s ease-in-out;
                }  
            }
            &:hover{
                svg path{
                    fill: $darkLight;
                }
            }
        }
    }
}
</style>